module.exports = __webpack_public_path__ + "img/fm.5748d380.svg";